<template>
  <table class="tableSize flipTable">
    <tr>
      <th class="tableHeader" v-for="(head, n) in header" :key="n">
        {{head}}
      </th>
    </tr>
    <tbody>
      <tr v-for="(data, index) in viewData" v-if="showData(data.ad_knd_nm)" :key="index">
        <td class="sortCenter">
          {{data.ad_knd_nm}}
        </td>
        <td class="sortCenter">
          {{data.geo_nm}}
        </td>
        <td class="sortRight">
          <div class="data_wrap">
            {{parseDataType(data.imp_cnt)}}
          </div>
        </td>
        <td class="sortRight">
          <div class="data_wrap">
            {{parseDataType(data.click_cnt)}}
          </div>
        </td>
        <td class="sortRight">
          <div class="data_wrap">
            {{data.ctr.toFixed(2)}}
          </div>
        </td>
      </tr>
      <tr>
        <td class="sortCenter total"><b>합계</b></td>
        <td></td>
        <th v-for="(data, key) in totalKey" class="sortCenter" :key="key">
          <div class="data_wrap">
            {{parseData(totalData[data], data)}}
          </div>
        </th>
      </tr>
    </tbody>
  </table>
</template>

<script>
  import { parseDataType, parseData } from '@/assets/func'

  export default {
    name: 'geoTable',
    props: {
      viewData: Array,
      checkRadio: String
    },
    data () {
      return {
        header: [
          '광고상품',
          '지역명',
          '노출수',
          '클릭수',
          'CTR(%)'
        ],
        totalKey: [
          'imp_cnt',
          'click_cnt',
          'ctr'
        ]
      }
    },
    methods: {
      parseDataType (data, key) {
        return parseDataType(data, key)
      },
      parseData (data, key) {
        return parseData(data, key)
      },
      showData (name) {
        if (this.checkRadio === 'all') {
          return true
        }
        return name === this.checkRadio
      },
      getTotalData (dataList) {
        let result = {
          imp_cnt: 0,
          click_cnt: 0,
          ctr: 0
        }
        let showData = this.showData
        dataList.forEach(el => {
          if (showData(el.ad_knd_nm)) {
            result.imp_cnt += el.imp_cnt
            result.click_cnt += el.click_cnt
          }
        })
        result.ctr = result.click_cnt / result.imp_cnt * 100
        result.ctr = isNaN(result.ctr) ? 0 : result.ctr

        return result
      }
    },
    computed: {
      totalData () {
        return this.getTotalData(this.viewData)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// GeoTable.vue?579f11e3